import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { palette, spacing } from 'c1ui'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        container: {
            border: `1px solid ${palette.border.primary}`,
            margin: 0,
            marginTop: theme.spacing(3),
            borderRadius: C1BorderRadius.large,
            '& .MuiTable-root': {
                borderCollapse: 'collapse',
            },
            '& .MuiTableHead-root': {
                position: 'relative',
                border: 'none',
            },
            '& .MuiTableHead-root:before': {
                content: '""',
                position: 'absolute',
                height: '1px',
                left: '0',
                right: '0',
                bottom: '-1px',
            },
            '& .MuiTableHead-root:after': {
                content: '""',
                position: 'absolute',
                height: '1px',
                left: '0',
                right: '0',
                bottom: '0',
            },
        },
        underline: {
            paddingTop: theme.spacing(1),
        },
        simpleTitle: {
            paddingTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        margin: {
            marginBottom: theme.spacing(3),
        },
        listContents: {
            width: '100%',
        },
        boxListContents: {
            width: '100%',
            margin: theme.spacing(1),
        },
        header: {
            '& .MuiTableCell-stickyHeader': {
                background: palette.grey[50],
                backgroundClip: 'padding-box',
                borderBottom: `1px solid ${palette.border.primary}`,
                padding: theme.spacing(1, '3px'),
            },
            '& .MuiTableCell-stickyHeader:first-child': {
                paddingLeft: theme.spacing(3),
            },
            '& .MuiTableCell-stickyHeader:last-child': {
                paddingRight: theme.spacing(3),
            },
        },
        row: {
            border: 0,
            '& .MuiTableRow-root': {
                backgroundColor: palette.grey[50],
                borderBottom: `1px solid ${palette.border.subtle}`,
                '&:hover': {
                    backgroundColor: palette.grey[50],
                },
                '&:nth-of-type(odd)': {
                    backgroundColor: palette.background.default,
                    '&:hover': {
                        backgroundColor: palette.background.default,
                    },
                },
            },
            '& .MuiTableRow-root:last-child': {
                borderBottom: 'none',
            },
            '& .MuiTableCell-root': {
                padding: theme.spacing(1),
                border: 0,
            },
            '& .MuiTableCell-root:first-child': {
                paddingLeft: theme.spacing(3),
            },
            '& .MuiTableCell-root:last-child': {
                paddingRight: theme.spacing(3),
            },
        },
        button: {
            marginLeft: theme.spacing(1),
        },
        questionMark: {
            fontSize: '10pt',
            fill: palette.grey[800],
            cursor: 'pointer',
            verticalAlign: 'middle',
            marginLeft: spacing.xs,
            marginBottom: '2px',
        },
        additionalInfo: {
            marginBottom: theme.spacing(1),
            marginLeft: theme.spacing(2),
        },
        searchContainer: {
            display: 'flex',
            alignItems: 'center',
            margin: 0,
            borderWidth: '1px',
            borderRadius: C1BorderRadius.large,
            backgroundColor: 'grey.50',
        },
        buttonContainer: {
            marginLeft: 'auto',
            margin: theme.spacing(1, 0, 0, 0),
        },
        simple: { paddingLeft: 0, paddingTop: '10px' },
    })
})

export const TableHeaderStyles: moduleStyleType = {
    margin1: {
        marginLeft: 1,
    },
    margin2: {
        marginLeft: 1,
    },
}
